import {createApiCall} from '../utils';
import {SERVICE_NAMES} from '../constants';
import type {
    ApiCallOptions,
    PaginatedResponse,
    CallbackEndpointResource,
    CallbackMessageResource,
    StoreEndpointRequest,
    UpdateEndpointRequest,
    EndpointsListParams,
    MessagesListParams
} from './api.d';

export const getEndpoints = (accountId: string, params?: EndpointsListParams, options: ApiCallOptions = {}) =>
    createApiCall<PaginatedResponse<CallbackEndpointResource>>(SERVICE_NAMES.CALLBACK, 'GET', `accounts/${accountId}/endpoints`)({...options, params});

export const createEndpoint = (accountId: string, data: StoreEndpointRequest, options: ApiCallOptions = {}) =>
    createApiCall<CallbackEndpointResource>(SERVICE_NAMES.CALLBACK, 'POST', `accounts/${accountId}/endpoints`)({...options, data});

export const getEndpoint = (accountId: string, endpointId: string, options: ApiCallOptions = {}) =>
    createApiCall<CallbackEndpointResource>(SERVICE_NAMES.CALLBACK, 'GET', `accounts/${accountId}/endpoints/${endpointId}`)({...options});

export const updateEndpoint = (accountId: string, endpointId: string, data: UpdateEndpointRequest, options: ApiCallOptions = {}) =>
    createApiCall<CallbackEndpointResource>(SERVICE_NAMES.CALLBACK, 'PUT', `accounts/${accountId}/endpoints/${endpointId}`)({...options, data});

export const deleteEndpoint = (accountId: string, endpointId: string, options: ApiCallOptions = {}) =>
    createApiCall<void>(SERVICE_NAMES.CALLBACK, 'DELETE', `accounts/${accountId}/endpoints/${endpointId}`)({...options});

export const getEndpointMessages = (accountId: string, endpointId: string, params?: MessagesListParams, options: ApiCallOptions = {}) =>
    createApiCall<PaginatedResponse<CallbackMessageResource>>(SERVICE_NAMES.CALLBACK, 'GET', `accounts/${accountId}/endpoints/${endpointId}/messages`)({...options, params});

export const resendMessage = (messageId: string, options: ApiCallOptions = {}) =>
    createApiCall<void>(SERVICE_NAMES.CALLBACK, 'POST', `resend-endpoint-message/${messageId}`)({...options});

export const callbackApi = {
    getEndpoints,
    createEndpoint,
    getEndpoint,
    updateEndpoint,
    deleteEndpoint,
    getEndpointMessages,
    resendMessage
};
